"use client";

const TimelineYear = ({ year }) => {
  return (
    <span className="float-left clear-left relative mx-auto mb-10 w-full text-center h-[41px]">
      <span className="absolute text-base font-bold leading-8 text-center whitespace-nowrap bg-white rounded-md border-solid border-[3px] border-neutral-200 decoration-neutral-800 h-[41px] left-[50px] text-neutral-800 w-[70px]">
        {year}
      </span>
    </span>
  );
};

export default TimelineYear;
